import { EnterpriseMember } from 'models/Enterprises';

export type TopPerformingBroker = Pick<
  EnterpriseMember,
  'user' | 'totalDeals' | 'totalListings' | 'totalLeads' | 'businessUnitName'
>;

export const TABLE_COLUMNS: Array<keyof TopPerformingBroker> = [
  'user',
  'totalDeals',
  'totalListings',
  'totalLeads',
  'businessUnitName',
];

export const HEADING_TRANSLATIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  user: 'broker',
  totalDeals: 'deals',
  totalListings: 'listings',
  totalLeads: 'leads',
  businessUnitName: 'unit',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  user: 'sortName',
  totalDeals: 'totalDeals',
  totalListings: 'totalListings',
  totalLeads: 'totalLeads',
};

export const SIZE_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  user: 320,
  totalDeals: 30,
  totalListings: 50,
  totalLeads: 50,
  businessUnitName: 150,
};
